const LoginIcon = ({ className, stroke }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.5988 3.59985L14.3988 3.59985C16.845 3.59985 16.7988 6.79985 16.7988 9.99985C16.7988 13.1999 16.845 16.3999 14.3988 16.3999H11.5988M12.3988 9.99985L2.79883 9.99985M12.3988 9.99985L9.19883 13.1999M12.3988 9.99985L9.19883 6.79985"
        stroke={stroke || "#55B12D"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LoginIcon;
